<script setup lang="ts">
/**
 * The org's logo in its brand square, or the product mark when it has none.
 * The image keeps its proportions on a light background: a logo is drawn for
 * paper, not for the accent colour.
 */
import Icon from './Icon.vue'

withDefaults(defineProps<{ url?: string | null; size?: number }>(), { size: 32 })
</script>

<template>
  <span v-if="url" :style="{ width: `${size}px`, height: `${size}px` }"
        class="grid flex-none place-items-center overflow-hidden rounded-input border border-border bg-white p-0.5">
    <img :src="url" alt="" class="max-h-full max-w-full object-contain" />
  </span>
  <span v-else :style="{ width: `${size}px`, height: `${size}px` }"
        class="grid flex-none place-items-center rounded-input bg-primary text-primary-foreground">
    <Icon name="phone-incoming" :size="Math.round(size * 0.53)" :stroke-width="2.25" />
  </span>
</template>
